import React, { useState, useEffect } from 'react';
import API from "../util/FingerPrintAuthApi";
import FingerPrintImage from "../assets/images/fingerprint-scan-animation.gif"
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@material-ui/lab/Alert';

const FingerPrintAuth = (props) => {

    const dispatch = useDispatch();
    // const [deviceStatus, setDeviceStatus] = useState(" ");
    const [quality, setQuality] = useState("Loading....");
    const [connectedDevice, setConnectedDevice] = useState("");
    // const [scannedFingerPrint, setScannedFingerPrint] = useState("");
    // const [verifyResponse, setVerifyResponse] = useState("");
    const [backgroundcolor, setBackgroundcolor] = useState("#ff6961");
    const [statusMessage, setstatusMessage] = useState("Fingerprint device disconnected - Please insert device to proceed");
    const [showHideFingerPrintImage, setshowHideFingerPrintImage] = useState("none");

    const { authFunc } = props;

    useEffect(() => {
        Promise.all([
            //_loadScript('/library/es6-shim.js'),
            _loadScript('../../public/scripts/fingerprint.sdk.min.js'),
            _loadScript('../../public/scripts/websdk.client.bundle.min.js')
        ]).then(() => {
            // Fingerprint should be available on the window.
            //console.log("Fingerprint ", window.Fingerprint);
            onScriptLoad();
        });
    }, []);

    const _loadScript = (src) => {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('async', 'true');
            script.setAttribute('src', src);
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    const getDeviceList = (sdk) => {
        sdk.enumerateDevices()
            .then(response => {
                setConnectedDevice(response[0]);
            })
            .catch(err => {
                // console.log('Error')
            })
    }

    const onScriptLoad = () => {
        const _sdk = new window.Fingerprint.WebApi();
        _sdk.onDeviceConnected = (e) => {
            onDeviceStatusChange("Fingerprint device connected - Scan your finger to proceed", "#0095ff")
            setshowHideFingerPrintImage("");
            getDeviceList(_sdk);
        };
        _sdk.onDeviceDisconnected = (e) => {
            onDeviceStatusChange("Fingerprint device disconnected - Please connect device to proceed", "#ff6961")
            setshowHideFingerPrintImage("none");
            setConnectedDevice(" ");
            stopCapture(_sdk);
        };
        _sdk.onCommunicationFailed = (e) => {
            // Detects if there is a failure in communicating with U.R.U web SDK
            onDeviceStatusChange("Fingerprint device disconnected - Please connect device to proceed", "#ff6961")
            setshowHideFingerPrintImage("none");
            setConnectedDevice(" ");
        };

        _sdk.onSamplesAcquired = (s) => {
            dispatch(
                authFunc({
                    DATA: JSON.parse(s.samples)[0].Data
                })
            )
        };

        //Revise this
        _sdk.onQualityReported = (e) => {
            setQuality(e.quality);
        };

        startCapture(_sdk);
    }

    const startCapture = (sdk) => {
        //console.log("Start fingerprint for verification")
        const currentFormat = 2;
        sdk.startAcquisition(currentFormat).then(function (data) {
            //console.log("You can start capturing !!!");
        }, function (error) {
           // console.log(error.message);
        });
    };

    const stopCapture = (sdk) => {
        sdk.stopAcquisition().then(() => {
            //console.log('capturing stoped')
        }, function (error) {
            //console.log('stop error', error)
        });
    };

    const onDeviceStatusChange = (inputEntry, statusColor) => {
        if (inputEntry && statusColor) {
            //this.setState({ statusMessage: inputEntry, backgroundcolor: statusColor })
            setstatusMessage(inputEntry);
            setBackgroundcolor(statusColor);
        }
    }

    return (
        <div>
            <Alert style={{ backgroundColor: backgroundcolor, width: "100%", textAlign: "center", fontSize: "16px", color: "#fff" }}>{statusMessage}</Alert>
            <center>
                <img style={{ width: "80%" }} src={FingerPrintImage} alt="Scan you finger" />
            </center>
        </div>
    );

}
export default FingerPrintAuth;